import { faIcon } from "@utils/faIcon"

import { Skeleton } from "@particles/index"

import { Icon } from "@atoms/index"

import { useJobPreviewCard } from "@pages/Jobs/JobList/views/JobTimelineView/JobPreviewCard/JobPreviewCard.context"

import styles from "./JobPreviewLocationDetail.module.scss"
import { JobPreviewLocationDetailProps } from "./JobPreviewLocationDetail.types"

export default function JobPreviewLocationDetail(props: JobPreviewLocationDetailProps) {
    const { location } = props

    const { isLoading } = useJobPreviewCard()

    if (isLoading && !location) {
        return <Skeleton width={16} height={16} />
    }

    return (
        <div className={styles.base}>
            <span className={styles.jobLocationIcon}>
                <Icon icon={faIcon({ name: "map", style: "regular" })} />
            </span>
            <p className={styles.locationAddress}>{location}</p>
        </div>
    )
}
